import React from "react";
import { Link } from "react-router-dom";
import { amountDisplay } from "../../Utils/Common";

interface ViewDataGroupProps {
    title: string;
    value?: string | number | null;
    isAmount?: boolean;
    isValueTextCapitalized?: boolean;
    titleWrapClassName?: string;
    titleClassName?: string;
    valueWrapClassName?: string;
    valueClassName?: string;
    isLink?: boolean;
    isValueHighlighted?: boolean;
}

const ViewDataGroup: React.FC<ViewDataGroupProps> = (
    {
        title,
        value,
        isAmount,
        titleWrapClassName = 'col-6 col-sm-5',
        titleClassName,
        valueWrapClassName = 'col-6 col-sm-7',
        valueClassName,
        isLink = false,
        isValueTextCapitalized = true,
        isValueHighlighted = false
    }
) => {

    return (
        <div className="view_data_group">
            <div className="row">
                <div className={titleWrapClassName}>
                    <h5 className={`view_data_title ${titleClassName ?? ''}`}>
                        {title} :
                    </h5>
                </div>
                <div className={valueWrapClassName}>
                    {isLink ? (
                        <React.Fragment>
                            {value ? (
                                <Link to={String(value)}
                                    target="_blank"
                                    className="view_data_content text_purple">
                                    {value}
                                </Link>
                            ) : (
                                <h5 className="view_data_content">---</h5>
                            )}
                        </React.Fragment>
                    ) : isAmount ? (
                        <React.Fragment>
                            {value !== null ? (
                                <h5 className="view_data_content">
                                    {amountDisplay(Number(value ?? 0))}
                                </h5>
                            ) : (
                                <h5 className="view_data_content">---</h5>
                            )}
                        </React.Fragment>
                    ) : (
                        <h5 className={`view_data_content 
                            ${isValueTextCapitalized ? 'text-capitalize' : 'first_letter_capitalized'} 
                            ${valueClassName ?? ''}
                            ${isValueHighlighted ? 'text_bold text_purple' : ''}
                        `}>
                            {value || '---'}
                        </h5>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ViewDataGroup;